module.exports = __webpack_public_path__ + "static/media/HH-image.4416ecff.png";